import axios from 'axios';
import React, { createContext, useRef, useState } from "react";
import defaultBackgroundImage from '../images/capture_decran_20240313_a_16271.jpg';
import {
    ADD_COMMENTS_URL,
    CITY_URL, COUNTRY_CODE_URL,
    COUNTRY_URL,
    EVENT_ASSOCIATE_URL,
    EVENTS_BASE_URL,
    EVENT_FORMAT_URL,
    EVENT_LAST_VISIT_URL,
    EVENT_TYPE_URL,
    EVENT_USERS_URL,
    FAMILY_USERS,
    GET_SITECODES,
    GET_HISTORY_URL,
    MLT_USERS,
    SEND_VALIDATION_URL,
    STATE_URL,
    UPDATE_NONEDIT_URL,
    EVENT_ATTACHMENTS_URL,
    EVENT_BRIEFS_URL,
    EVENT_COVER_URL
} from './ApiDetails.js';
import { confirm } from '../utilities/Confirm.tsx';

const FormContext = createContext({});

export const FormProvider = ({ children }) => {

    const title = {
        0: 'Event',
        1: 'Schedule',
        2: 'Guests',
        3: 'History',
        4: 'Summary'
    }

    const [page, setPage] = useState(0)
    const [firstGet, setFirstGet] = useState(false)
    const [nonEditable, setNonEditable] = useState(false)
    const [errors, setErrors] = useState({})
    const [eventTypeList, setEventTypes] = useState([])
    const [eventFormatList, setEventFormat] = useState([])
    const [lastVisitList, setlastVisit] = useState([])
    const [associateAtEvent, setassociateAtEvent] = useState([])
    const [associateAtEventChecked, setassociateAtEventChecked] = useState([])
    const [checkBoxSelected, setCheckBoxSelected] = useState(false)
    const [country, setcountry] = useState([])
    const [state, setstate] = useState([])
    const [city, setcity] = useState([])
    const [users, setUsers] = useState([])
    const [familyUsers, setFamilyUsers] = useState([])
    const [MLTUsers, setMLTUsers] = useState([])
    const hiddenUploadImageFileInput = useRef(null);
    const hiddenUploadBriefFileInput = useRef(null);
    const hiddenAttachmentFileInput = useRef(null);
    const [briefs, setBriefs] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [siteCodelist, setSiteCodes] = useState([]);
    const [phoneCodeList, setPhoneCodeList] = useState([]);
    const [suggestion, setSuggestions] = useState([]);
    const [suggestionCoHost, setSuggestionsCoHost] = useState([]);
    const [HistoryComment, setHistoryComment] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [files, setFiles] = useState([]);
    const [isCoverImageUploaded, setIsCoverImageUploaded] = useState(false);
    const [showConfirmationModalDeleteUpload, setShowConfirmationModalDeleteUpload] = useState(false);

    var assoDrop = [];

    const toggleAssociatesCheckbox = (e) => {
        const value = e.target.value;
        const checked = e.target.checked;

        setCheckBoxSelected(true);
        const updatedAssociates = associateAtEventChecked.map((associate) => {
            if (associate.value === value) {
                return { ...associate, checked: checked }; // Update checked state
            }
            return associate;
        });

        // Update the state with the new array
        setassociateAtEventChecked(updatedAssociates);
    };

    // to capture the value on click
    const selectSuggestionValue = (item) => {
        eventFormData.requestedBy = item
        setSuggestions("")
    }

    const handleEmailValidation = (e) => {
        const email = e.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (email && !emailRegex.test(email)) {
            // Handle invalid email
            setErrors({ ...errors, coHostEmail: 'Please enter a valid email address' });
        } else {
            // Clear the error if email is valid or empty
            setErrors({ ...errors, coHostEmail: '' });
        }
    };

    const selectFamilyGuest = (guest) => {
        eventFormData.mem.push(guest);
    }

    const removeFamilyGuest = (guest) => {
        const index = eventFormData.mem.indexOf(guest);
        if (index > -1) { // only splice array when item is found
            eventFormData.mem.splice(index, 1); // 2nd parameter means remove one item only
        }
    }

    const selectMltGuest = (guest) => {
        eventFormData.mlt.push(guest);
    }

    const removeMltGuest = (guest) => {
        const index = eventFormData.mlt.indexOf(guest);
        if (index > -1) { // only splice array when item is found
            eventFormData.mlt.splice(index, 1); // 2nd parameter means remove one item only
        }
    }

    const selectSuggestionValueCoHost = (item) => {
        eventFormData.eventCoHost = item
        setSuggestionsCoHost("")
    }

    const handleUploadImageClick = () => {
        hiddenUploadImageFileInput.current.click();
    };

    const handleUploadBriefFileClick = () => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading the brief.");
        else
            hiddenUploadBriefFileInput.current.click();
    };

    const handleUploadAttachmentClick = () => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading attachments.");
        else
            hiddenAttachmentFileInput.current.click();
    };

    const onScheduleLoad = async () => {
        if (eventFormData.eventId != 0) {
            axios.get(`${EVENT_BRIEFS_URL}/${eventFormData.eventId}`)
                .then(async response => {
                    if (response.data != null && response.data.length != 0) {
                        setBriefs(response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching brief file or file data', error);
                });

            axios.get(`${EVENT_ATTACHMENTS_URL}/${eventFormData.eventId}`)
                .then(response => {
                    if (response.data != null && response.data.length != 0) {
                        setAttachments(response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching attachments', error);
                });
        }
    }

    const setEmail = () => {
        if (page == 0) {
            eventFormData.email = localStorage.getItem('email');
            document.getElementById("email").readOnly = true;
        }
    }

    const setRequestedBy = () => {
        if (page == 0) {
            eventFormData.requestedBy = `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}`;
            document.getElementById("requestedBy").readOnly = true;
        }
    }

    const handleCommentText = (e) => {
        setHistoryComment(e.target.value)
    }

    const [headerRefresh, setHeaderRefresh] = useState(false);
    const refreshNotifications = () => {
        setHeaderRefresh(!headerRefresh);
    }

    const addComments = async () => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before adding comments.");
        else {
            let commData = new FormData();
            commData.append("EventId", eventFormData.eventId);
            commData.append("Comments", HistoryComment);

            axios.post(ADD_COMMENTS_URL, commData)
                .then(response => {
                    if (response.data != null) {
                        refreshNotifications();
                        setHistoryComment("")
                        createHistoryElements(response.data.comments, response.data.date, response.data.user, response.data.userRole, true)
                    }
                    else
                        alert("Error adding comments");
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                    alert("Error adding comments");
                });

        }

    }

    const onHistoryLoad = async () => {
        if (eventFormData.eventId != 0) {
            await axios.get(`${GET_HISTORY_URL}/${eventFormData.eventId}`)
                .then(response => {
                    if (response.data.length != 0) {
                        var eleh = document.getElementById("History");
                        if (eleh) eleh.innerHTML = "";
                        response.data.forEach(element => {
                            if (element.history != null)
                                createHistoryElements(element.history, element.date, element.user, element.userRole, false)
                            if (element.comments != null)
                                createHistoryElements(element.comments, element.date, element.user, element.userRole, true)
                        });
                    }
                });
        }

    }

    const createHistoryElements = (data, date, user, userRole, isComment) => {
        var ele = document.getElementById("History")
        //Date Div
        var dateDiv = document.createElement("div")
        dateDiv.className = "form-group row mb-2 align-items-center"
        //date label
        var datelabel = document.createElement("label")
        datelabel.className = "custom-font col-sm-2 col-form-label"
        datelabel.innerText = new Date(date).toLocaleDateString('en-US', {timeZone: 'UTC'});
        //div user
        var userDiv = document.createElement("div")
        userDiv.className = "col-sm-2 "
        var userStrong = document.createElement("strong")
        var userInput = document.createElement("input")
        userInput.type = "text"
        userInput.className = "custom-font-lt form-control-plaintext-cus form-control-plaintext"
        userInput.value = user
        userStrong.appendChild(userInput);
        //role
        var roleInput = document.createElement("input")
        roleInput.type = "text"
        roleInput.className = "custom-font-lt form-control-plaintext-cus form-control-plaintext"
        roleInput.value = userRole
        //comments
        var commentsDiv = document.createElement("div")
        commentsDiv.className = "form-group row mb-2"
        var commentsDiv1 = document.createElement("div")
        commentsDiv1.className = "col-sm-12 "
        var commentsInput = document.createElement("div");
        commentsInput.style.whiteSpace = "pre-wrap";
        commentsInput.style.wordWrap = "break-word";
        commentsInput.className = "custom-font-lt form-control";
        commentsInput.textContent = data;
        if (isComment)
            commentsInput.className = "custom-font-lt form-control comment"
        if (ele != null) {
            commentsDiv1.appendChild(commentsInput)
            commentsDiv.appendChild(commentsDiv1)

            userDiv.appendChild(userStrong)
            userDiv.appendChild(roleInput)

            dateDiv.appendChild(datelabel)
            dateDiv.appendChild(userDiv)
            ele.appendChild(dateDiv)
            ele.appendChild(commentsDiv)
        }

    }

    const handleAttachmentsUpload = (e) => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading attachments.");
        else {
            let attachData = new FormData();
            attachData.append("File", e.target.files[0]);
            attachData.append("EventId", eventFormData.eventId);//eventFormData.eventId
            const headers = {
                'Content-Type': 'multipart/form-data'
            }
            axios.post(EVENT_ATTACHMENTS_URL, attachData, { headers })
                .then(response => {
                    setAttachments([...attachments, response.data]);
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                    alert("Error uploading attachment");
                });
        }
    };

    const [eventFormData, setEventFormData] = useState({
        // Initialize your form data state here
        createdBy: '',
        requestedBy: '',
        eventTitle: '',
        associateSegment: '',
        email: '',
        phone: '',
        phoneCode: '',
        eventDate: '',
        siteCode: '',
        countryName: '',
        stateName: '',
        cityName: '',
        eventVenueName: '',
        eventAddress: '',
        eventType: '',
        eventFormat: '',
        totalAttendees: 0,
        petcareAttendees: 0,
        schedule: {
            visitSummary: '',
            draftItinerary: ''
        },
        maxFamilyNum: false,
        familyNum: 1,
        specificFamilyMem: false,
        mem: [],
        IsScheduleChange: false,
        lastVisit: '',
        associates: '',
        IsImageCover: false,
        eventId: 0,
        eventStatus: 'Draft',
        eventEndDate: '',
        mltEvent: false,
        MaxMLTNum: false,
        specificMLTMem: false,
        mlt: [],
        mltNum: '',
    });
    const { ...requiredInputs } = eventFormData

    const handleChange = e => {
        e.preventDefault();
        var name = e.target.name
        var value = e.target.value
        let errorMessage = '';

        // Perform validation for each field
        if (name === 'requestedBy' && value.trim() === '') {
            errorMessage = 'Requested by is required';
        } else if (name === 'eventTitle' && value.trim() === '') {
            errorMessage = 'Event title is required';
        } else if (name === 'associateSegment' && value.trim() === '') {
            errorMessage = 'Associate segment is required';
        } else if (name === 'email' && value.trim() === '') {
            errorMessage = 'Email is required';
        } else if (name === 'phone' && value.trim() === '') {
            errorMessage = 'Phone is required';
        } else if (name === 'phoneCode' && value.trim() === '') {
            errorMessage = 'Phone code is required';
        } else if (name === 'eventDate' && value.trim() === '') {
            errorMessage = 'Event date is required';
        } else if (name === 'eventEndDate' && value.trim() === '') {
            errorMessage = 'Event enddate is required';
        } else if (name === 'siteCode' && value.trim() === '') {
            errorMessage = 'Site code is required';
        } else if (name === 'eventType' && value.trim() === '') {
            errorMessage = 'Event type is required';
        } else if (name === 'eventFormat' && value.trim() === '') {
            errorMessage = 'Event format is required';
        } else if (name === 'totalAttendees' && value.trim() === '') {
            errorMessage = 'Total attendees is required';
        } else if (name === 'email' && !(/^\S+@\S+\.\S+$/.test(value))) {
            errorMessage = 'Please enter a valid email address';
        } else if (name === 'phone' && !(/^[0-9]+$/.test(value))) {
            errorMessage = 'Please enter a valid phone number';
        } else if (name === 'lastVisit' && value.trim() === '') {
            errorMessage = 'Please select a range for last visit';
        } else if (name === "otherEventFormat" && eventFormData.eventFormat == "Other" && value.trim() === '') {
            errorMessage = 'Please specify the other event format ';
        } else if (name === "otherEventType" && eventFormData.eventType == "Other" && value.trim() === '') {
            errorMessage = 'Please specify the other event type ';
        }

        setErrors({ ...errors, [name]: errorMessage });

        if ((e != null) && (e.target != null) && (e.target.options != null) && (e.target.options[e.target.selectedIndex] != null)) {
            if (name == "eventType" || name == "eventFormat" || name == "lastVisit" || name == "cityName") {
                value = e.target.options[e.target.selectedIndex].text
            }

            if (name == "countryName") {
                value = e.target.options[e.target.selectedIndex].text
                fetchState(e.target.options[e.target.selectedIndex].text);
            }

            if (name == "stateName") {
                value = e.target.options[e.target.selectedIndex].text
                fetchCity(e.target.options[e.target.selectedIndex].text);
            }
        }

        if (name === 'isDateFlexible') {
            value = e.target.checked
        }
        else if (name === 'eventDate') {
            setEventFormData((prevData) => {
                let updatedData = { ...prevData, [name]: value };
                if (!prevData.eventEndDate || prevData.eventEndDate === prevData.eventDate) {
                    updatedData.eventEndDate = value;
                }
                return updatedData;
            });
        }
        else if (name === 'mltEvent') {
            value = e.target.checked
            setEventFormData({ ...eventFormData, "mltEvent": value })
        }
        else if (name === 'imageFile') {
            setEventFormData({ ...eventFormData, "IsImageCover": false })
            const bgUrl = URL.createObjectURL(e.target.files[0])
            document.getElementById('hdrDiv').style.backgroundImage = 'url(' + bgUrl + ')';

            name = "IsImageCover"
            value = true
        }
        else if (name == 'requestedBy') {
            let value = e.target.value;
            let matches = [];

            if (value.length >= 1) {
                const regex = new RegExp(`${value.toLowerCase()}`);
                matches = users.filter((item) => regex.test(item.toLowerCase()));
            }
            setSuggestions(matches);
        }
        else if (name == "eventCoHost") {
            let value = e.target.value;
            let matches = [];

            if (value.length >= 1) {
                const regex = new RegExp(`${value.toLowerCase()}`);
                matches = users.filter((item) => regex.test(item.toLowerCase()));
            }
            setSuggestionsCoHost(matches);
        }
        else {
            value = e.target.value
        }

        setEventFormData(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const [imageData, setImageData] = useState(null);

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        setImageData(file);
    }

    const imageUploadApi = async () => {
        const formData = new FormData();
        formData.append("EventId", eventFormData.eventId);
        formData.append("File", imageData);

        try {
            const response = await axios.post(
                EVENT_COVER_URL,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Accept: "text/plain",
                    },
                }
            );

            if (response.data) {
                var hdrDiv = document.getElementById("hdrDiv");

                await axios.get(`${EVENT_COVER_URL}/${eventFormData.eventId}`)
                    .then(response => {
                        // Set background image based on cover image availability
                        if (response.data === '') {
                            hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                            setIsCoverImageUploaded(false);
                        } else {
                            hdrDiv.style.backgroundImage = `url(${response.data})`;
                            setIsCoverImageUploaded(true);

                            setEventFormData((prevData) => {
                                const updatedData = {
                                    ...prevData,
                                    IsImageCover: true,
                                };

                                return updatedData;
                            });
                        }
                    })
                    .catch(error => {
                        console.error("Error fetching event details:", error);
                        hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                        setIsCoverImageUploaded(false);
                    });
            }
        } catch (error) {
            console.error(
                "Error uploading cover image:",
                error.response || error.message
            );
        }
    }

    const handleScheduleAgendaChange = (e) => {
        eventFormData.schedule.visitSummary = e;
        eventFormData.IsScheduleChange = true;

    };
    const handleScheduleItenaryChange = (e) => {
        eventFormData.schedule.draftItinerary = e;
        eventFormData.IsScheduleChange = true;

    };

    const fetchEventTypes = async () => {
        try {
            const response = await axios.get(EVENT_TYPE_URL);

            setEventTypes(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchEventFormat = async () => {
        try {
            const response = await axios.get(EVENT_FORMAT_URL);

            setEventFormat(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await axios.get(EVENT_USERS_URL);

            setUsers(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchfamilyUsers = async () => {
        try {
            const response = await axios.get(FAMILY_USERS);

            setFamilyUsers(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchMLTUsers = async () => {
        try {
            const response = await axios.get(MLT_USERS);

            setMLTUsers(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchSiteCodes = async () => {
        try {
            const response = await axios.get(GET_SITECODES);

            setSiteCodes(response.data);
        } catch (error) {
            console.error('Error fetching site codes:', error);
        }
    };

    const fetchLastVisit = async () => {
        try {
            const response = await axios.get(EVENT_LAST_VISIT_URL);

            setlastVisit(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchAssociateAtEvent = async () => {
        if (associateAtEvent.length === 0) {
            try {
                const response = await axios.get(EVENT_ASSOCIATE_URL);
                var AssociateAtEventData = [];
                response.data.forEach(element => {
                    AssociateAtEventData.push({
                        value: element,
                        checked: false
                    })
                });
                setassociateAtEvent(response.data);
                assoDrop = AssociateAtEventData;
                setassociateAtEventChecked(AssociateAtEventData)
            } catch (error) {
                console.error('Error fetching event types:', error);
            }
        }
        else {
            return
        }
    };

    const fetchCountry = async () => {
        try {
            const response = await axios.get(COUNTRY_URL);
            setcountry(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchState = async (countryName) => {
        try {
            const response = await axios.get(STATE_URL + countryName);

            setstate(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const fetchCity = async (stateName) => {
        try {
            const responseCity = await axios.get(CITY_URL + stateName);

            setcity(responseCity.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const canSubmit = [...Object.values(requiredInputs)].every(Boolean) && page === Object.keys(title).length - 1

    const handlepageChange = (val) => {
        //setFirstGet
        var page = window.location.href.split('/')[3];

        if (page == 'getDetail' && firstGet) {
            setPage(val);

            if (val === 1) {
                onScheduleLoad()
            }
            if (val === 3) {
                onHistoryLoad()
            }
        }
        else {
            setPage(val);

            if (val === 1) {
                onScheduleLoad()
            }
            if (val === 3) {
                onHistoryLoad()
            }
        }
    }

    async function handleSubmit(e, pNomessage) {
        e.preventDefault();

        // Reset errors
        let newErrors = {};

        // Basic validations
        if (!eventFormData.requestedBy) setRequestedBy();
        if (!eventFormData.eventTitle) newErrors.eventTitle = 'Event title is required';
        if (!eventFormData.associateSegment) newErrors.associateSegment = 'Associate segment is required';

        if (!eventFormData.email) setEmail();
        if (!eventFormData.phone) newErrors.phone = 'Phone is required';
        if (!eventFormData.eventDate) newErrors.eventDate = 'Event date is required';
        if (!eventFormData.eventEndDate) newErrors.eventEndDate = 'Event date is required';
        if (!isEventOffSite && !eventFormData.siteCode) newErrors.siteCode = 'Site code is required';
        if (!eventFormData.eventType) newErrors.eventType = 'Event type is required';
        if (!eventFormData.eventFormat) newErrors.eventFormat = 'Event format is required';
        if (!eventFormData.lastVisit) newErrors.lastVisit = 'LastVisit is required';
        if (!eventFormData.totalAttendees) newErrors.totalAttendees = 'Total attendees is required';
        if (!eventFormData.mltEvent && (eventFormData.familyNum === 0)) {
            newErrors.familyNum = 'Please specify the minimum family number';
        }
        //mlt 
        if (eventFormData.mltEvent && (eventFormData.mltNum === 0)) {
            newErrors.mltNum = 'Please specify the minimum MLT number';
        }
        if (eventFormData.eventFormat === "Other" && !eventFormData.otherEventFormat) {
            newErrors.otherEventFormat = 'Please specify the other event format';
        }
        if (eventFormData.eventType === "Other" && !eventFormData.otherEventType) {
            newErrors.otherEventType = 'Please specify the other event type';
        }

        // Email validation
        const emailPattern = /^\S+@\S+\.\S+$/;
        if (eventFormData.email && !emailPattern.test(eventFormData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        // Phone validation
        const phonePattern = /^[0-9]+$/;
        if (eventFormData.phone && !phonePattern.test(eventFormData.phone)) {
            newErrors.phone = 'Please enter a valid phone number';
        }

        if (isEventOffSite) {
            eventFormData.eventAddress = searchAddress;
            if (!eventFormData.eventAddress) {
                newErrors.eventAddress = 'Please enter an address for the external event';
            }
        }

        const associateMapping = {
          "Corporate": "marsCorporateAttendees",
          "Food & Nutrition & Multisales": "marsFoodNutritionAttendees",
          "Mars Global Services": "marsGlobalServicesAttendees",
          "Multisales": "marsMultisalesAttendees",
          "Snacking": "marsSnackingAttendees",
          "Petcare": "marPetCareAttendees",
          "Veterinary Health": "marsVeterinaryHealthAttendees",
        };
        associateAtEventChecked.forEach(element => {
            const apiName = associateMapping[element.value]; // Get the API name
            if ((element.checked) && !eventFormData[apiName]) {
                newErrors[apiName] = 'Please enter a number of attendees';
            }
            if ((!element.checked)) eventFormData[apiName] = null;
        });

        setErrors(newErrors);

        // If no errors, proceed with form submission
        if (Object.keys(newErrors).length === 0) {
            // Proceed with form submission
            if (eventFormData.eventStatus === "") eventFormData.eventStatus = "Draft";
            if (checkBoxSelected) {
                var asso = "";
                associateAtEventChecked.forEach(element => {
                    if (element.checked) {
                        asso = asso + element.value + ",";
                    }
                });
                asso = asso.slice(0, -1);
                eventFormData.associates = asso;
            }
            eventFormData.mltEvent = eventFormData.mltEvent || false;
            eventFormData.familyNum = eventFormData.familyNum || 0;
            eventFormData.mltNum = eventFormData.mltNum || 0;

            if (isEventOffSite) {
                eventFormData.siteCode = "OFF";
                eventFormData.countryName = "";
                eventFormData.cityName = "";
                eventFormData.stateName = "";
                eventFormData.eventAddress = searchAddress;
                eventFormData.eventVenueName = searchAddress.split(",")[0];
            }

            let updatedEventData = {
                ...eventFormData,
            }

            const response = await axios.post(EVENTS_BASE_URL, updatedEventData);
            if (response.data != null) {
                eventFormData.id = response.data[0];
                eventFormData.eventId = response.data[1];
                eventFormData.IsScheduleChange = false;
                imageUploadApi();
                if (pNomessage !== "noMessage") alert("Event updated successfully.");
                return true;
            } else {
                alert("Error updating the details");
                return false;
            }
        } else {
            alert("Check for validation errors before submitting");
            return false;
        }
    }

    const handleBriefUpload = (e) => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading the brief.");
        else {
            let briefData = new FormData();
            briefData.append("File", e.target.files[0]);
            briefData.append("EventId", eventFormData.eventId);
            const headers = {
                'Content-Type': 'multipart/form-data'
            }
            axios.post(EVENT_BRIEFS_URL, briefData, { headers })
                .then(async response => {

                    alert("Brief updated.");
                    setBriefs([...briefs, response.data]);
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                    alert("Error uploading brief");
                });
        }
    };

    const handleBriefDelete = async (e, eventId, name) => {
        e.preventDefault();

        const confirmResult = await confirm({ title: 'Confirm', message: 'Are you sure you want to delete this brief file?' });
        if (confirmResult) {
            try {
                await axios.delete(`${EVENT_BRIEFS_URL}/${eventId}/${encodeURIComponent(name)}`)
                    .then(res => {
                        if (res.data === true) {
                            var ele = document.getElementById(decodeURIComponent(name))
                            ele.remove()
                        }
                        else {
                            alert("Error deleting Brief");
                        }
                    });
            }
            catch (error) {
                console.error('Error deleting', error);
            }
        }
    };

    const handleAttachmentDelete = async (e, eventId, name) => {
        e.preventDefault()

        const confirmResult = await confirm({ title: 'Confirm', message: 'Are you sure you want to delete this attachment?' });
        if (confirmResult) {
            try {
                await axios.delete(`${EVENT_ATTACHMENTS_URL}/${eventId}/${encodeURIComponent(name)}`)
                    .then(res => {
                        if (res.data === true) {
                            var ele = document.getElementById(decodeURIComponent(name))
                            ele.remove()
                        }
                        else {
                            alert("Error deleting Attachment");
                        }
                    })
            } catch (error) {
                console.error('Error deleting', error);
            }
        }
    };

    const handleDeleteDraft = async () => {
        const confirmResult = await confirm({ title: 'Confirm', message: 'Are you sure you want to permanently delete this draft?' });
        if (confirmResult) {
            await axios.delete(`${EVENTS_BASE_URL}/${eventFormData.eventId}`)
                .then(response => {
                    if (response.data > 0) {
                        alert("Draft deleted.");
                        var ele = document.getElementById("backBtn");
                        ele.click();
                    }
                    else {
                        alert("Error: unable to delete the Draft!");
                    }
                })
                .catch(error => {
                    console.error('Error deleting', error);
                    alert(`Error: unable to delete the Draft\n${error.response.data}`);
                })
        }
    }

    const handleNonEditableUI = () => {
        var form = document.getElementById("createNewRequestForm");
        var elements = form.elements;
        var editor = document.getElementsByClassName("ql-editor")
        for (var i = 0, len = elements.length; i < len; ++i) {
            if (elements[i].type == 'select-one' || elements[i].type == 'checkbox') {
                elements[i].disabled = true;
            }
            if (elements[i].type == 'text') {
                elements[i].readOnly = true;
            }
            if (elements[i].id == 'closeEdit' || elements[i].id == 'deleteDraft' || elements[i].id == 'saveChanges'
                || elements[i].id == 'sendValidation' || elements[i].id == 'uploadBrief'
                || elements[i].id == 'deleteBrief' || elements[i].id == 'uploadAttachment'
                || elements[i].id == 'coverImageUpload'
            ) {
                elements[i].disabled = true;
            }
        }
        if (editor != null) {
            for (var j = 0, l = editor.length; j < l; ++i) {
                editor[j].contentEditable = false;
            }
        }
        setNonEditable(true)
    }

    const handleNonEditable = async () => {
        if (eventFormData.eventId === 0)
            alert("No details saved");
        else {
            try {
                await axios.post(`${UPDATE_NONEDIT_URL}/${eventFormData.eventId}`)
                    .then(response => {
                        if (response.data > 0) {
                            handleNonEditableUI()
                        }
                        else {
                            alert("Error in makinng the draft non editable");
                        }
                    })
                    .catch(error => {
                        console.error('Error updating the details: ', error);
                        alert("Error in makinng the draft non editable");
                    });
            } catch (error) {
                console.error('Error in makinng the draft non editable', error);
            }
        }
    };

    async function handleSendForValidation(e) {
        const submitRes = await handleSubmit(e, "noMessage");
        if (!submitRes) return;

        if (eventFormData.eventId === 0) {
            alert("No details saved");
            return;
        }

        try {
            // Call validation API
            const response = await axios.post(`${SEND_VALIDATION_URL}/${eventFormData.eventId}`);

            if (response.data > 0) {
                // Handle success
                setShowModal(true);
                const status = eventFormData.mltEvent ? "Open event" : "Under review";
                statusHiglight(status);
            } else if (response.data === -1) {
                alert("Already sent for validation");
            } else {
                alert("Error in sending for validation");
            }
        } catch (error) {
            console.error("Error in sending for validation", error);
            alert("Error in sending for validation");
        }
    }

    const closeModal = () => {
        setShowModal(false);
        window.history.back();
    };

    const statusHiglight = (status) => {
        var eventStatusTab = document.getElementById("eventStatusTab");
        if (eventStatusTab == null) return;
        var ele = eventStatusTab.childNodes;
        ele.forEach(element => {
            element.className = "btn-custom btn btn-default"

        });
        switch (status) {
            case "Draft":
                document.getElementById("Draft").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Under review":
                document.getElementById("UnderReview").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Open event":
                document.getElementById("OpenEvent").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Attendance confirmed":
                document.getElementById("AttendanceConfirmed").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Pending documentation":
                document.getElementById("PendingDocumentation").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Completed":
                document.getElementById("Completed").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Rejected":
                if (document.getElementById("Rejected")) document.getElementById("Rejected").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Cancelled":
                if (document.getElementById("Cancelled")) document.getElementById("Cancelled").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            default:
                document.getElementById("Draft").className = "btn-custom btn btn-default selectbreadcrumb"
        }
    }

    const getEventById = (eventID) => {
        if (!firstGet) {
            try {
                axios.get(`${EVENTS_BASE_URL}/${eventID}`)
                    .then(response => {
                        var data = response.data;
                        if (data != null) {
                            eventFormData.id = data.id
                            eventFormData.requestedBy = data.requestedBy
                            eventFormData.eventTitle = data.eventTitle
                            eventFormData.eventStatus = data.eventStatus
                            eventFormData.requestedBy = data.requestedBy
                            eventFormData.associateSegment = data.associateSegment
                            eventFormData.countryName = (data.countryName != null) ? data.countryName.trim() : null;
                            eventFormData.stateName = (data.stateName != null) ? data.stateName.trim() : null;
                            eventFormData.cityName = (data.cityName != null) ? data.cityName.trim() : null;
                            eventFormData.email = data.email
                            eventFormData.phone = data.phone
                            eventFormData.phoneCode = data.phoneCode
                            eventFormData.eventDate = data.eventDate;
                            eventFormData.eventEndDate = data.eventEndDate;
                            eventFormData.siteCode = data.siteCode
                            eventFormData.otherSiteCode = data.otherSiteCode
                            eventFormData.lastVisit = data.lastVisit
                            eventFormData.isDateFlexible = data.isDateFlexible
                            eventFormData.mltEvent = data.mltEvent
                            eventFormData.eventVenueName = data.eventVenueName
                            eventFormData.eventAddress = data.eventAddress
                            eventFormData.eventType = data.eventType
                            eventFormData.eventFormat = data.eventFormat
                            if (data.siteCode === "OFF") {
                                setSearchAddress(data.eventAddress);
                            }

                            setNonEditable(data.IsEditable)
                            if (eventFormData.eventType == "Other") {
                                eventFormData.otherEventType = data.otherEventType
                            }

                            if (eventFormData.eventFormat == "Other") {
                                eventFormData.otherEventFormat = data.otherEventFormat
                            }

                            eventFormData.eventCoHost = data.eventCoHost
                            eventFormData.coHostEmail = data.coHostEmail
                            eventFormData.maxFamilyNum = data.maxFamilyNum
                            eventFormData.familyNum = data.familyNum
                            eventFormData.specificFamilyMem = data.specificFamilyMem
                            eventFormData.mem = data.mem

                            eventFormData.MaxMLTNum = data.maxMLTNum
                            eventFormData.mltNum = data.mltNum
                            eventFormData.specificMLTMem = data.specificMLTMem
                            eventFormData.mlt = data.mlt

                            eventFormData.associates = data.associates
                            eventFormData.petcareAttendees = data.petcareAttendees
                            //map attendees with data attributes
                            eventFormData.marsCorporateAttendees =
                                data.marsCorporateAttendees;
                            eventFormData.marsFoodNutritionAttendees =
                                data.marsFoodNutritionAttendees;
                            eventFormData.marsGlobalServicesAttendees =
                                data.marsGlobalServicesAttendees;
                            eventFormData.marsMultisalesAttendees =
                                data.marsMultisalesAttendees;
                            eventFormData.marsSnackingAttendees = data.marsSnackingAttendees;
                            eventFormData.marPetCareAttendees = data.marPetCareAttendees;
                            eventFormData.marsVeterinaryHealthAttendees =
                                data.marsVeterinaryHealthAttendees;

                            if (data.schedule != null) {

                                data.schedule.visitSummary != null
                                    ? eventFormData.schedule.visitSummary = data.schedule.visitSummary
                                    : eventFormData.schedule.visitSummary = ""

                                data.schedule.draftItinerary != null

                                    ? eventFormData.schedule.draftItinerary = data.schedule.draftItinerary
                                    : eventFormData.schedule.draftItinerary = ""
                            }

                            fetchAssociateAtEvent().then(() => {
                                if (data.associates && data.associates !== "") {
                                    setCheckBoxSelected(true);
                                    var asso = data.associates
                                    var assoList = asso.split(",");
                                    assoDrop.forEach(element => {
                                        assoList.forEach(ass => {
                                            if (ass.trimEnd() === element.value.trimEnd()) {

                                                element.checked = true;
                                            }

                                        });
                                    });
                                    setassociateAtEventChecked(assoDrop);
                                }
                            })

                            if (data.IsEditable) {
                                handleNonEditableUI()
                            }

                            assoDrop.forEach(element => {
                                if (element.checked) {
                                    var ele = document.getElementById(element.value)
                                    ele.checked = true;
                                }
                            });

                            eventFormData.totalAttendees = data.totalAttendees
                            statusHiglight(eventFormData.eventStatus);
                        }
                    })
                    .catch(error => {
                        console.error('Error updating the details: ', error);
                    });

            } catch (error) {
                console.error('Error in makinng the draft non editable', error);
            }
        }
    }

    const fetchPhonecode = async () => {
        try {
            const response = await axios.get(COUNTRY_CODE_URL);
            setPhoneCodeList(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    const [searchAddress, setSearchAddress] = useState("");
    const [isEventOffSite, setIsEventOffSite] = useState(false);

    return (
        <FormContext.Provider value={{
            title, page, setPage, eventFormData, setEventFormData, canSubmit, handleChange, assoDrop,
            handlepageChange, setErrors, errors, fetchEventTypes, fetchEventFormat, fetchLastVisit,
            fetchAssociateAtEvent, fetchCountry, fetchPhonecode, fetchState, fetchCity, eventTypeList,
            eventFormatList, lastVisitList, associateAtEvent, country, phoneCodeList, state, city,
            handleScheduleAgendaChange, handleScheduleItenaryChange, handleSubmit,
            handleUploadImageClick, hiddenUploadImageFileInput, handleBriefUpload,
            handleUploadBriefFileClick, hiddenUploadBriefFileInput,
            hiddenAttachmentFileInput, handleUploadAttachmentClick, handleAttachmentsUpload,
            handleBriefDelete, handleAttachmentDelete, handleDeleteDraft, handleNonEditable, handleNonEditableUI,
            nonEditable, handleSendForValidation, fetchUsers, users, suggestion, selectSuggestionValue,
            selectSuggestionValueCoHost, attachments, briefs, suggestionCoHost, HistoryComment, setHistoryComment, handleCommentText,
            addComments, toggleAssociatesCheckbox, associateAtEventChecked,
            checkBoxSelected, statusHiglight, setRequestedBy, getEventById, firstGet, setFirstGet,
            familyUsers, setFamilyUsers,
            fetchfamilyUsers, siteCodelist, fetchSiteCodes, setEmail, handleEmailValidation, closeModal, showModal, setMLTUsers,
            fetchMLTUsers, MLTUsers, files, setFiles, handleImageUpload,
            selectFamilyGuest, removeFamilyGuest, selectMltGuest, removeMltGuest,
            searchAddress, setSearchAddress, isEventOffSite, setIsEventOffSite, isCoverImageUploaded, setIsCoverImageUploaded,
            headerRefresh, setHeaderRefresh, refreshNotifications,
            showConfirmationModalDeleteUpload, setShowConfirmationModalDeleteUpload
        }}>
            {children}
        </FormContext.Provider>
    )
}
export default FormContext 